import axios, { AxiosRequestConfig } from "axios";
import auth, { AuthServiceType } from "shared/Auth0";
import { BASE_API_URL } from "store/Me";

const baseURL = BASE_API_URL;

export default interface AbstractResponseModel<T> {
  data: T;
}

const getAuthHeaderValue = async (authResponse: AuthServiceType) => {
  // If user is logged in, get the token from the login provider.
  if (auth.isAuthenticated()) {
    return `Bearer ${localStorage.getItem("access_token")}`;
  }
};

/**
 * Non-hook version for making authorized requests. Safe to call anywhere.
 */
export async function makeAuthedRequest<T = void>(
  request: Partial<AxiosRequestConfig>,
) {
  const { data } = await axios.request<T>({
    baseURL,
    ...request,
    headers: {
      ...request.headers,
      Authorization: await getAuthHeaderValue(auth),
    },
  });

  return data;
}

const useMakeAuthedRequest = () => {
  // Keep the existing hook API for callers that expect a hook.
  return makeAuthedRequest;
};

export { useMakeAuthedRequest };
